import { React, useRef } from 'react';
import styled from 'styled-components';

const MemberShipInfoBox = (props) => {
  const { isOver, data, index, modifyClickFn, deleteClickFn } = props;

  const TopLevelRef = useRef();
  const ButtonRef = useRef();

  function mouseOver() {
    TopLevelRef.current.style.border = `1px solid #FF8B48`;
    ButtonRef.current.style.opacity = 1;
  }

  function mouseLeave() {
    TopLevelRef.current.style.border = `1px solid #DFDFDF`;
    ButtonRef.current.style.opacity = 0;
  }

  function modifyClick() {
    modifyClickFn(index);
  }

  function deleteClick() {
    deleteClickFn(index)
  }

  return (
    <TopLevelWrapper ref={TopLevelRef} isOver={isOver} onMouseOver={mouseOver} onMouseLeave={mouseLeave}>
      <TextWrapper isOver={isOver}>
        <Text>{data.name}</Text>
        <ButtonWrapper ref={ButtonRef} isOver={isOver}>
          <Button isOver={isOver} color='#595959' onClick={modifyClick}>수정</Button>
          <Button isOver={isOver} color='#FF3131' onClick={deleteClick}>삭제</Button>
        </ButtonWrapper>
      </TextWrapper>
      <InfoWrapper isOver={isOver}>
        <InfoBox isOver={isOver}>
          <InfoText isOver={isOver}>{data.totalMax === -1 ? '무제한' : data.totalMax + '회'}</InfoText>
        </InfoBox>
        <InfoBox isOver={isOver}>
          <InfoText isOver={isOver}>{data.validity}일</InfoText>
        </InfoBox>
        <InfoBox isOver={isOver}>
          <InfoText isOver={isOver}>{data.price}원</InfoText>
        </InfoBox>
      </InfoWrapper>
    </TopLevelWrapper>
  )
}

export default MemberShipInfoBox;

const TopLevelWrapper = styled.div`
  display: flex;
  flex-direction: column;

  justify-content: center;
  align-items: center;

  width: ${props => props.isOver ? `max(634px, 82.55208333333333vw)` : `max(240px, 74.375vw)`};
  height: ${props => props.isOver ? `67px` : `59px`};

  border: 1px solid #DFDFDF;
  border-radius: 15px;
  background-color: #FFFFFF;

  margin: 8px 0 0 0;

  transition: all 0.3s ease-in-out;

  &:hover {
    cursor: pointer;
  }
`;

const TextWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: space-between;
  align-items: center;

  // width: 95%;
  width: ${props => props.isOver ? `max(604px, 78.64583333333333vw)` : `max(208px, 65vw)`};

  margin-top: ${props => props.isOver ? `10px` : `8px`};
`;

const Text = styled.div`
  display: flex;

  font-family: NotoSansKR-Regular;
  font-size: 14px;

  color: #595959;

  margin: 0 0 0 0;
`;

const ButtonWrapper = styled.div`
  display: flex;
  flex-direction: row;

  gap: ${props => props.isOver ? `8px` : `4px`};

  opacity: 0;

  transition: all 0.3s ease-in-out;
`;

const Button = styled.p`
  font-family: NotoSansKR-Regular;
  font-size: ${props => props.isOver ? `14px` : `12px`};

  color: ${props => props.color};

  margin: 0 0 0 0;

  // &:hover {
  //   cursor: pointer;
  // }
`;

const InfoWrapper = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: flex-start;
  align-items: center;
  
  gap: 4px;
  margin: ${props => props.isOver ? `5px 0 10px 0` : `8px 0 8px 0`};

  // width: 95%;
  width: ${props => props.isOver ? `max(604px, 78.64583333333333vw)` : `max(208px, 65vw)`};

`;

const InfoBox = styled.div`
  display: flex;
  flex-direction: row;

  justify-content: center;
  align-items: center;

  border-radius: ${props => props.isOver ? `8px` : `4px`};
  background-color: #CBCBCB;
`;

const InfoText = styled.div`
  font-fmaily: NotoSansKR-Regular;
  font-size: ${props => props.isOver ? `12px` : `10px`};

  color: #FFFFFF;

  margin: ${props => props.isOver ? `3px 8px 4px 8px` : `2px 4px 2px 4px`};
`;